export default __webpack_public_path__ + "7dce81e154bb10820613484e97e42b45.png";